import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Users, Shield, Award, Coffee } from 'lucide-react';
export function SocialClubs() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-581">
      <Header data-id="element-582" />

      <main className="pt-32 pb-24" data-id="element-583">
        <section className="max-w-7xl mx-auto px-6 mb-32 text-center" data-id="element-584">
          <span className="section-overline" data-id="element-585">Partnerships</span>
          <h1 className="text-[#4A0E0E] mb-8" data-id="element-586">Private Organizations</h1>
          <p className="text-[#2C2C2C]/60 max-w-3xl mx-auto text-lg" data-id="element-587">
            Cork Dorx provides curated wine culture and educational programming
            for the region's most prestigious social clubs and member-only
            organizations.
          </p>
        </section>

        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-588">
          <div className="bg-[#2D0909] text-white rounded-[3rem] overflow-hidden grid grid-cols-1 lg:grid-cols-2" data-id="element-589">
            <div className="p-12 md:p-24 flex flex-col justify-center" data-id="element-590">
              <h2 className="text-4xl font-serif mb-8" data-id="element-591">
                Elevating Club Culture
              </h2>
              <p className="text-white/70 mb-10 leading-relaxed" data-id="element-592">
                We work closely with club management to enhance their existing
                hospitality offerings. From staff training to private member
                tastings, we bring a new level of sophistication to the club
                experience.
              </p>
              <div className="space-y-6" data-id="element-593">
                <div className="flex items-start gap-4" data-id="element-594">
                  <div className="bg-[#D4AF37]/20 p-3 rounded-xl text-[#D4AF37]" data-id="element-595">
                    <Shield size={20} data-id="element-596" />
                  </div>
                  <div data-id="element-597">
                    <h4 className="font-serif text-xl" data-id="element-598">
                      Exclusive Programming
                    </h4>
                    <p className="text-white/50 text-sm" data-id="element-599">
                      Customized events designed specifically for your
                      membership.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-600">
                  <div className="bg-[#D4AF37]/20 p-3 rounded-xl text-[#D4AF37]" data-id="element-601">
                    <Award size={20} data-id="element-602" />
                  </div>
                  <div data-id="element-603">
                    <h4 className="font-serif text-xl" data-id="element-604">Staff Education</h4>
                    <p className="text-white/50 text-sm" data-id="element-605">
                      Professional training for club hospitality teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-[600px] lg:h-auto" data-id="element-606">
              <img src="https://cdn.magicpatterns.com/uploads/r5hj3gjJymrNtQCVj7ETLs/pexels-ren-lavsad-379156630-18597836.jpg" alt="Social Club" className="w-full h-full object-cover" data-id="element-607" />
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-608" />
    </motion.div>;
}